import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-components";
import { Dismiss24Filled } from "@fluentui/react-icons";
import React from "react";
import { ExperimentDetails } from "../details-experiment/experiment-details.component";
import sidebarLogo from '../../assets/sidebar-logo.png';
import { getExperimentsClient } from "../../services/ai-for-pfd.service";
import { ExperimentResponseModel } from "../../swagger-clients/ai-for-pfd-clients.service";
import { processServerError } from "../../utils/helpers/error.helper";
import { ApplicationTryNowButton } from "../../components/application-try-now-button/application-try-now-button.component";
import { WizardApplication } from "../../components/create-experiment-wizard/create-experiment-wizard.modal";
import { HubConnection } from "@microsoft/signalr";

type ExperimentDetailsModalProps = {
    experimentId: number;
    hubConnection: HubConnection;
    exampleName?: string;
    isOpened?: boolean;
    onClose?: () => void;
}

export const ExperimentDetailsModal: React.FC<ExperimentDetailsModalProps> = (props) => {

    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        setOpen(!!props.isOpened);
    }, [props.isOpened]);


    const onClose = () => {
        setOpen(false);

        if (props.onClose) {
            props.onClose();
        }
    }


    return <Dialog open={open} onOpenChange={(event, data) => {
        setOpen(data.open);
        if (!data.open) {
            onClose();
        }

    }}>
        <DialogSurface style={{ minWidth: "95vw" }}>

            <DialogBody style={{ height: "90vh" }}>
                <DialogTitle action={<Button appearance="transparent" onClick={onClose} icon={<Dismiss24Filled />} />}
                    style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    {isLoading && <span>-</span>}
                    {!isLoading && <span>Flowsheet Copilot Example</span>}
                    <span style={{
                        color: "grey",
                        fontSize: "1rem",
                        fontWeight: "400",
                        fontStyle: "italic",
                        display: "flex",
                        alignItems: "center"
                    }}>
                        powered by  <img className="disable-visual-search" src={sidebarLogo} style={{ width: "auto", height: "40px" }} alt='Simulate 365 logo' /> </span>
                </DialogTitle>
                <DialogContent>
                    <ExperimentDetails experimentId={props.experimentId} isShared exampleName={props.exampleName} dataTableHeight="70vh" />

                </DialogContent>
                <DialogActions>
                    <ApplicationTryNowButton hubConnection={props.hubConnection} application={WizardApplication.Copilot} />
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>
}
